import { render } from "./HDFCopyright.vue?vue&type=template&id=214f0aa2&scoped=true"
const script = {}

import "./HDFCopyright.vue?vue&type=style&index=0&id=214f0aa2&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214f0aa2"]])

export default __exports__